import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { AddUserVS } from 'shared/utils/validation/AuthValidation';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import { useFormik } from 'formik';
import Select from 'react-select';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';

import UploadAvatar from 'shared/components/common/upload_avatar/UploadAvatar';
import { uploadFileMedia } from 'shared/services/media_service/Media_Service';
import { RoleList } from './Constant';

export default function UserAdd({ show, handleClose, submitUser, userList, setUserList, isEdit = false }) {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const [selectedProject, setSelectedProject] = useState(false);
    const [avatarFile, setAvatarFile] = useState(null);
    const [selectedImg, setSelectedImg] = useState('');
    const selectionHandler = (item) => {
        setSelectedProject(item);
    };

    const initialValues = {
        username: '',
        email: '',
        password: '',
        authorize: ''
    };
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: AddUserVS,
        onSubmit: async (value) => {
            let userDetail = {
                name: value.username,
                email: value.email,
                password: value.password,
                authorize: value.authorize.value
            };
            if (typeof avatarFile != 'string') {
                if (avatarFile) {
                    let resp = await uploadMedia();
                    if (resp?.data) {
                        userDetail['profile_image'] = resp?.data?.url;
                    }
                }
            }
            submitUser(userDetail);

            formik.resetForm();
            handleClose();
        }
    });
    const { handleChange, handleSubmit, values, touched, errors, setFieldValue } = formik;

    const uploadMedia = async () => {
        try {
            let fileBody = new FormData();
            fileBody.append('image', avatarFile);
            return await uploadFileMedia(fileBody);
        } catch (error) { }
    };
    return (
        <Modal show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className={styles.Header}>
                <Heading heading={'Add User'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <UploadAvatar UploadedFile={avatarFile} setFile={setAvatarFile} selectedImg={selectedImg} setSelectedImg={setSelectedImg} />

                <div className={classNames(styles.AddLinkContainer)}>
                    <CustomInput
                        label={'User Name'}
                        placeholder={'e.g. John'}
                        type="text"
                        value={values.username}
                        onChange={(e) => {
                            setFieldValue('username', e.target.value);
                            // setSupplierVal(e.target.value);
                        }}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        error={errors.username && touched.username ? errors.username : ''}
                    />
                    <CustomInput
                        label={'Email'}
                        type={'email'}
                        placeholder={'e.g. John'}
                        value={values.email}
                        onChange={(e) => {
                            setFieldValue('email', e.target.value);
                            // setSupplierVal(e.target.value);
                        }}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        error={errors.email && touched.email ? errors.email : ''}
                    />
                    <CustomInput
                        label={'Password'}
                        type={'password'}
                        placeholder={'e.g. John'}
                        value={values.password}
                        onChange={(e) => {
                            setFieldValue('password', e.target.value);
                            // setSupplierVal(e.target.value);
                        }}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        error={errors.password && touched.password ? errors.password : ''}
                    />
                    <label className="LightFontColor Label style_InputLabel__lhse5">Role</label>
                    <Select
                        className={values.brand ? '' : classNames(styles.disable)}
                        options={RoleList}
                        isSearchable
                        isClearable
                        value={values.authorize}
                        placeholder="Select Role"
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        onChange={(item) => {
                            setFieldValue('authorize', item);
                        }}
                    />
                    <div className="Error"> {errors.authorize && touched.authorize ? errors.authorize : ''}</div>

                    <div className="d-flex justify-content-end">
                        <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={handleClose} />
                        <CustomButton
                            text={'Create User'}
                            containerStyle={styles.SubmitBtn}
                            submitHandle={() => {
                                handleSubmit();
                            }}
                        />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
